import React from 'react';
import PropTypes from 'prop-types';
import twemoji from 'twemoji';

import { EMOJI_LIB_ENDPOINT_BASE } from '../../../constants/pro-custom-prints';

const propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

const EmojiParsed = ({ text, className = 'emoji-inline', ...props }) => {
  if (!text) {
    return '';
  }

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: twemoji.parse(text, {
          base: `${EMOJI_LIB_ENDPOINT_BASE}/`,
          folder: 'svg',
          ext: '.svg',
          className,
          ...props,
        }),
      }}
    />
  );
};

EmojiParsed.propTypes = propTypes;

export default EmojiParsed;
